import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Select2Multiple from 'v-select2-multiple-component';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import axios from "axios";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import Loading from 'vue-loading-overlay';
import CONFIG from "@/assets/js/config.js";
import SelectAllService from '@/services/SelectAllService';
import HandlePaginateService from "@/services/HandlePaginateService";

export default {
  name: "attendanceTeacherList",
  components: {
    MainLayout,
    flatPickr,
    Select2Multiple,
    AdvancedLaravelVuePaginate,
    Loading,
  },

  mixins: [SelectAllService],

  data() {
    return {
      teacherNumber: '',
      teacherName: '',
      start_date: '',
      end_date: '',
      searchData: {
        teacher_number: '',
        name: '',
        start_date: '',
        end_date: '',
      },
      initialStartDate: '',
      initialEndDate: '',
      attendanceList: {},
      paginationData: {},
      noDataMsg: CONFIG.NO_DATA_FOUND,
      CONFIG,
      isLoading: false,
      search_status: false,
    };
  },

  methods: {
    getAttendanceList(page = 1) {
      this.isLoading = true;

      var request = {
        params: {
          start_date: this.initialStartDate,
          end_date: this.initialEndDate,
          page: page,
        }
      }

      axios.get("/teacher-attendance/attendanceList", request)
        .then(response => {
          if (page > 1 && !response.data.data.length) {
            this.getAttendanceList(page - 1);
            return;
          }

          this.getAttendanceData(response);
          this.isLoading = false;
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          console.log("Attendance List API Error", error);
          this.isLoading = false;
        });
    },

    search(page = 1) {
      this.isLoading = true;
      this.search_status = true;
      var request = {
        params: this.searchData
      }
      request.params.page = page;
      
      axios.get("/teacher-attendance/attendanceList", request)
        .then(response => {
          this.search_status = true;

          if (page > 1 && !response.data.data.length) {
            this.search(page - 1);
            return;
          }

          this.getAttendanceData(response);
          this.isLoading = false;
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          console.log("Teacher Attendance Search API Error", error);
          this.isLoading = false;
        });
    },

    filter() {
      this.resetSelectedAll();
      this.search_status = true;
      this.searchData.teacher_number = this.teacherNumber;
      this.searchData.name = this.teacherName;
      this.searchData.start_date = this.start_date;
      this.searchData.end_date = this.end_date;
      this.search();
    },

    getAttendanceData(res) {
        this.paginationData = res.data;
        this.currentCbs = [];
        this.attendanceList = res.data.data.map((att) => {
          this.storeCurretCbs(att.id);
          return {
            id: att.id,
            date: `${att.date} (${att.dayname})`,
            teacher_name: att.teacher_name,
            checkTimes: Object.entries(att)
                              .filter(([key]) => key.includes("actual_"))
                              .map(([,value]) => value),
          }
        });
    },

    reset() {
      this.teacherNumber = 
      this.teacherName = 
      this.start_date = 
      this.end_date = '',
      this.searchData = {
        teacherNumber: '',
        teacherName: '',
        start_date: '',
        end_date: '',
      };
      this.search_status = false;
      this.setInitialDateRange();
      this.resetSelectedAll();
      this.getAttendanceList();
    },

    clear() {
      this.requestDelete(
        "patch",
        "/teacher-attendance/clear", 
        'Attendance deleted successfully', 
        "Attendance deleted api Error"
      );
    },

    del() {
      this.requestDelete(
        "post", 
        "/teacher-attendance/deleteShiftAssigns", 
        'Attendance Shift Assigns deleted successfully', 
        "Attendance Shift Assigns deleted api Error"
      );
    },

    showCreate() {
      this.$router.push({
        path: "/attendanceTeacher/register"
      });
    },

    requestDelete(method, api, successMessage, errorMessage) {
      if (this.isEmptySelected(this.paginationData.total)) {
        this.$notification.error('Select at least one attendance', {
          timer: 3,
          position: "bottomCenter"
        });
        return;
      }

      if (!window.confirm("Are you sure you want to delete?")) {
        return;
      }

      const searchInfo = {
        teacher_number: this.teacherNumber,
        name: this.teacherName,
        start_date: this.initialStartDate ?? this.start_date,
        end_date: this.initialEndDate ?? this.end_date,
      };

      
      this.isLoading = true;
      axios[method](api, {
        attendance_ids: [...this.selectedIds],
        selected_all: this.selectedAllToggle,
        search: searchInfo,
      })
      .then(() => {
        this.resetSelectedAll();
        this.search(this.paginationData.current_page);
        this.$notification.success(successMessage, {
          timer: 3,
          position: "bottomCenter"
        });
      })
      .catch(error => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        console.log(errorMessage, error);
        this.isLoading = false;
      });
    },

    setInitialDateRange() {
      const formatDate = (date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
      };

      const now = new Date();
      this.initialStartDate = formatDate(new Date(now.getFullYear(), now.getMonth(), 1));
      this.initialEndDate = formatDate(new Date(now.getFullYear(), now.getMonth() + 1, 0));
    },

    handlePaginate(page) {
      HandlePaginateService.paginate({
        page,
        isSearch: this.search_status,
        searchFn: this.search,
        listFn: this.getAttendanceList
      })
    },
  },

  mounted() {
    this.isLoading = true;
    this.setInitialDateRange();
    this.getAttendanceList();
  },
};
